/*
 * MONTAGE · Vergleichspreis als Zeilen-Eigenschaft, nachgezogen je Variante
 * ---------------------------------------------------------------------------
 * Gehoert zu snippets/mt-regulaer-feld.liquid. Eine Aufgabe: das versteckte
 * Feld `properties[Regulär]` fuehrt immer den Streichpreis der Variante, die
 * im id-Feld des Formulars steht. Dawn schreibt beim Variantenwechsel nur
 * dieses id-Feld um (product-info.js, updateVariantInputs) und feuert darauf
 * ein change-Ereignis; daran haengt dieses Skript.
 *
 * Was hier NICHT passiert (EINGRIFFSREGELN.md § 2.2): kein fetch, kein
 * Formular, kein Eingriff in product-form.js. Es wird ein Wert in ein Feld
 * geschrieben, sonst nichts.
 */
(function () {
  function karteFuer(formId) {
    var el = document.querySelector('script[data-mt-regulaer-karte="' + formId + '"]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function verbinden(feld) {
    // Das Snippet steht im Kaufblock UND in der Sticky-Leiste, beide laden
    // dieses Skript. Jedes Feld wird trotzdem nur einmal verbunden.
    if (feld.dataset.mtRegulaerVerbunden !== undefined) return;
    feld.dataset.mtRegulaerVerbunden = '';
    var formId = feld.getAttribute('form');
    var form = formId && document.getElementById(formId);
    if (!form) return;
    var idFeld = form.querySelector('input[name="id"]');
    if (!idFeld) return;
    var karte = karteFuer(formId);

    var nachziehen = function () {
      // Der Stufen-Block sendet eigene items[] mit Eigenschaft und schaltet
      // Dawns id-Feld dafuer ab. Dann muss dieses Feld ebenfalls schweigen.
      var stufenAktiv = idFeld.dataset.mtStufen !== undefined;
      var wert = karte[idFeld.value];
      if (stufenAktiv || !wert) {
        feld.disabled = true;
        return;
      }
      feld.value = wert;
      feld.disabled = false;
    };

    nachziehen();
    idFeld.addEventListener('change', nachziehen);
    new MutationObserver(nachziehen).observe(idFeld, {
      attributes: true,
      attributeFilter: ['value', 'disabled', 'data-mt-stufen'],
    });
  }

  function start() {
    document.querySelectorAll('input[data-mt-regulaer]').forEach(verbinden);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
